export const PERMISSIONS = {
    Admin: "registros_fitossanitarios.admin",
    Visitante: "registros_fitossanitarios.visitante",
    ReguladorRead: "registros_fitossanitarios.regulador.read",
    ReguladorWrite: "registros_fitossanitarios.regulador.write",
    RequisitanteRead: "registros_fitossanitarios.requisitante.read",
    RequisitanteWrite: "registros_fitossanitarios.requisitante.write",
}